//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      randomHref: null,
      defaultHref:
        'https://webcamlander-1.meidenvanholland.nl/?utm_source=Website&utm_medium=banner&utm_campaign=10_min_free&utm_id=webcam+intro+actie',
      links: [
        'https://webcamlander-1.meidenvanholland.nl/?utm_source=Website&utm_medium=banner&utm_campaign=10_min_free&utm_id=webcam+intro+actie',
        'https://webcamlander-2.meidenvanholland.nl/?utm_source=Website&utm_medium=banner&utm_campaign=10_min_free&utm_id=webcam+intro+actie',
      ],
    };
  },
  mounted() {
    this.randomHref = this.links[Math.floor(Math.random() * this.links.length)];
  },
};
